/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/media-has-caption */
// @flow
import * as React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { fileLink } from 'common/utils/file-link';

import { Responsive } from 'client/components/common';

import defaultIconSrc from 'assets/client/heart-unselected-icon.svg';
import defaultSelectedIconSrc from 'assets/client/heart-selected-icon.svg';

import * as css from './MainContent.scss';

type Props = {|
	checklistInfo: ChecklistsItem,
	isSelected: boolean,
	title: string,
	id: string,
	onClickBtn: Function,
|};

type State = {
	isHover: boolean,
};

class SelectBtn extends React.PureComponent<Props, State> {
	state = {
		isHover: false,
	};

	onClick = (e: any) => {
		const { onClickBtn } = this.props;
		onClickBtn(e);
	};

	render() {
		const { checklistInfo, isSelected, title, id } = this.props;
		const isMobile = Responsive.isMatching(Responsive.MOBILE);
		const { isHover } = this.state;
		const normalText = _.get(checklistInfo, 'graphics.normalStateButtonText', 'לבחירה');
		const selectedText = _.get(checklistInfo, 'graphics.selectedStateButtonText', 'לבחירה');

		const normalTextColor = _.get(checklistInfo, 'graphics.normalStateButtonTextColor', '');
		const normalBgColor = _.get(checklistInfo, 'graphics.normalStateButtonBackground', '');
		const hoverTextColor = _.get(checklistInfo, 'graphics.hoverStateButtonTextColor', '');
		const hoverlBgColor = _.get(checklistInfo, 'graphics.hoverStateButtonBackground', '');
		const selectedTextColor = _.get(checklistInfo, 'graphics.selectedStateButtonTextColor', '');
		const selectedBgColor = _.get(checklistInfo, 'graphics.selectedStateButtonBackground', '');

		const clientIcon = _.get(checklistInfo, 'graphics.normalStateButtonIcon');
		const clientSelectedIcon = _.get(checklistInfo, 'graphics.selectedStateButtonIcon');

		const bgColor = isHover && !isSelected ? hoverlBgColor : normalBgColor;
		const textColor = isHover && !isSelected ? hoverTextColor : normalTextColor;
		const bColor = isHover && !isSelected ? hoverlBgColor : normalTextColor;

		return (
			<div
				className={classNames(css.selectBtn, isSelected && css.selected)}
				onMouseEnter={() => {
					if (!isMobile) {
						this.setState({ isHover: true });
					}
				}}
				onMouseLeave={() => {
					if (!isMobile) {
						this.setState({ isHover: false });
					}
				}}
				style={{
					backgroundColor: isSelected ? selectedBgColor : bgColor,
					color: isSelected ? selectedTextColor : textColor,
					borderColor: bColor,
				}}
				onClick={this.onClick}
				data-id={id}
				data-title={title}
			>
				<span>{isSelected ? selectedText : normalText}</span>
				<span className={css.iconWrapper}>
					{clientIcon && clientSelectedIcon ? (
						<>
							<img
								className={classNames(css.icon, (isSelected || isHover) && css.hide)}
								src={fileLink(clientIcon)}
								alt=""
							/>
							<img
								className={classNames(css.iconSelected, (isSelected || isHover) && css.show)}
								src={fileLink(clientSelectedIcon)}
								alt=""
							/>
						</>
					) : (
						<img
							className={css.defaultIcon}
							src={isSelected || isHover ? defaultSelectedIconSrc : defaultIconSrc}
							alt=""
						/>
					)}
				</span>
			</div>
		);
	}
}

export default SelectBtn;
